import React, { useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { SHIPMENT_STATUS_TEXT, SHIPMENT_STATUS_DESCRIPTION, SHIPMENT_STATUS_STYLES } from '../constants/orderConstants';

/**
 * Renders a shipment status label with an optional (?) icon that shows the
 * status description in a popover when clicked. Used for carrier-agnostic
 * display; descriptions are shown only on user click.
 */
function ShipmentStatusWithInfo({ status, showBadge = true, showIcon = true, className = '', size = 'sm' }) {
  if (!status) return null;
  const label = SHIPMENT_STATUS_TEXT[status] || status;
  const description = SHIPMENT_STATUS_DESCRIPTION[status];
  const style = SHIPMENT_STATUS_STYLES[status] || { bg: '#f8f9fa', text: '#6c757d' };

  if (!description) {
    return showBadge ? (
      <span className={className} style={{ backgroundColor: style.bg, color: style.text }}>{label}</span>
    ) : (
      <span className={className}>{label}</span>
    );
  }

  const popover = (
    <Popover id={`shipment-status-popover-${status}`} className="shadow">
      <Popover.Header as="h6">Kargo durumu açıklaması</Popover.Header>
      <Popover.Body className="small">{description}</Popover.Body>
    </Popover>
  );

  return (
    <span className={`d-inline-flex align-items-center gap-1 ${className}`}>
      {showBadge && (
        <span
          className={`badge rounded-pill border-0 ${size === 'sm' ? 'py-1 px-2' : 'py-2 px-3'}`}
          style={{ backgroundColor: style.bg, color: style.text }}
        >
          {label}
        </span>
      )}
      {!showBadge && <span>{label}</span>}
      {showIcon && (
        <OverlayTrigger trigger="click" placement="top" overlay={popover} rootClose>
          <button
            type="button"
            className="btn btn-link p-0 border-0 align-baseline text-muted"
            style={{ fontSize: '0.875rem', lineHeight: 1, minWidth: '1.25rem' }}
            aria-label="Durum açıklaması"
            title="Açıklama"
          >
            <i className="fas fa-question-circle" />
          </button>
        </OverlayTrigger>
      )}
    </span>
  );
}

export default ShipmentStatusWithInfo;
